/** Analytics event types per PRD §22.1 */
export type AnalyticsEvent =
  | { type: 'puzzle_start'; puzzleId: string; tier: number; category: string }
  | { type: 'puzzle_complete'; puzzleId: string; score: number; strikes: number; time: number; stars: number; resets: number; undoUsed: boolean }
  | { type: 'puzzle_abandon'; puzzleId: string; strikesUsed: number; resonancePercent: number }
  | { type: 'daily_complete'; date: string; score: number; streakLength: number }
  | { type: 'share'; puzzleId: string; channel: string }
  | { type: 'hint_used'; puzzleId: string; hintLevel: number }
  | { type: 'settings_change'; settingName: string; newValue: string };

/**
 * Dispatches an analytics event.
 *
 * The Funway SDK handles analytics internally via its specific methods
 * (submitScore, completeDailyChallenge, etc.) which are called from
 * the game store's recordSolve action. This function now serves as
 * a development-time logger for debugging event flow.
 */
export function trackEvent(event: AnalyticsEvent): void {
  if (import.meta.env.DEV) {
    console.debug('[analytics]', event.type, event);
  }
}
